import { CenterFlexColumn } from "styles/layout";
import { BannedTrackName, BanName } from "../styles";
import { selectRosterDisplayName } from "selectors/Roster";
import { selectTrackNameFromTournamentId } from "selectors/Tournament";
import { useAppSelector } from "app/hooks";

interface Props {
  trackId: string;
  rosterId: string | undefined;
  tournamentId: string;
}

export const RoundsBasedBan = ({ trackId, rosterId, tournamentId }: Props) => {
  const trackName = useAppSelector((state) =>
    selectTrackNameFromTournamentId(state, trackId, tournamentId)
  );

  const displayName = useAppSelector((state) =>
    !!rosterId
      ? selectRosterDisplayName(state, rosterId, tournamentId)
      : undefined
  );

  return (
    <CenterFlexColumn>
      <BannedTrackName>
        {trackName}
        <BanName> - {displayName ?? "unknown"} ban</BanName>
      </BannedTrackName>
    </CenterFlexColumn>
  );
};
